/** Display number as locale string (e.g. "1,000") with the given precision
 * @param { Number } n The number to display or format
 * @param {number} [precision=0] Precision to use for display, defaults to zero.
 */
export default function formatNumber(n, precision = 0) {
  let multiplier = 1;

  for (let i = 0; i < precision; i++) {
    multiplier *= 10;
  }

  return (Math.round(n * multiplier) / multiplier).toLocaleString();
}
